import { requestJson } from "../api/apiClient";

export async function fetchVehicleSavedSearches() {
  return requestJson("/api/mobility/vehicle-saved-searches");
}

export async function fetchVehicleSavedSearch(id) {
  return requestJson(`/api/mobility/vehicle-saved-searches/${encodeURIComponent(id)}`);
}

export async function createVehicleSavedSearch(payload) {
  return requestJson("/api/mobility/vehicle-saved-searches", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export async function updateVehicleSavedSearch(id, payload) {
  return requestJson(`/api/mobility/vehicle-saved-searches/${encodeURIComponent(id)}`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  });
}

export async function deleteVehicleSavedSearch(id) {
  return requestJson(`/api/mobility/vehicle-saved-searches/${encodeURIComponent(id)}`, {
    method: "DELETE",
  });
}

export async function evaluateVehicleSavedSearch(id) {
  return requestJson(
    `/api/mobility/vehicle-saved-searches/${encodeURIComponent(id)}/evaluate`,
    { method: "POST", body: JSON.stringify({}) }
  );
}

export async function fetchVehicleAlerts(params = {}) {
  const search = new URLSearchParams();
  if (params.unseenOnly) search.set("unseen_only", "true");
  if (params.eventType) search.set("event_type", params.eventType);
  if (params.savedSearchId) search.set("saved_search_id", params.savedSearchId);
  if (params.limit) search.set("limit", String(params.limit));
  const q = search.toString();
  return requestJson(`/api/mobility/vehicle-alerts${q ? `?${q}` : ""}`);
}

export async function markVehicleAlertSeen(id) {
  return requestJson(`/api/mobility/vehicle-alerts/${encodeURIComponent(id)}/mark-seen`, {
    method: "POST",
  });
}

export async function dismissVehicleAlert(id) {
  return requestJson(`/api/mobility/vehicle-alerts/${encodeURIComponent(id)}/dismiss`, {
    method: "POST",
  });
}

export async function fetchAdminVehicleAlertDiagnostics() {
  return requestJson("/api/admin/mobility/vehicle-alerts");
}
